import React, { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import './AdminDashboard.css';

const AdminDashboard = () => {
    const [queueData, setQueueData] = useState({
    blot: { free: 0, five: 0, ten: 0, twenty: 0 },
    rps: { free: 0, five: 0, ten: 0, twenty: 0 },
    carrom: { free: 0, five: 0, ten: 0, twenty: 0 },
    backgammon: { free: 0, five: 0, ten: 0, twenty: 0 },
    poker: { free: 0, five: 0, ten: 0, twenty: 0 },  
});
    const [ongoingGames, setOngoingGames] = useState([]);
    const [completedGames, setCompletedGames] = useState([]);
    const [usdtBets, setUsdtBets] = useState(0);
    const [starsBets, setStarsBets] = useState(0);
    const [tokenBets, setTokenBets] = useState(0);
    const [userCount, setUserCount] = useState(0);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [pendingWithdrawals, setPendingWithdrawals] = useState([]);
    const [isLoadingWithdrawals, setIsLoadingWithdrawals] = useState(false);

    const navigate = useNavigate();

    // Ref to the audio element
    const audioRef = useRef(null);

    const fetchData = async () => {
        const headers = { 'Content-Type': 'application/json' };

        // Armenia Time Offset (UTC+4)
        const armOffset = 4 * 60 * 60 * 1000;

        // Calculate Armenia start date
        const startDateArmenia = new Date(startDate);
        startDateArmenia.setHours(0, 0, 0, 0);
        const startDateUTC = new Date(startDateArmenia.getTime() + armOffset);

        // Calculate Armenia end date
        const endDateArmenia = new Date(endDate);
        endDateArmenia.setHours(23, 59, 59, 999);
        const endDateUTC = new Date(endDateArmenia.getTime() + armOffset);

        const resOngoing = await fetch('/api/admin/ongoing-games', {
            method: 'GET',
            headers,
            credentials: 'include',
        });
        setOngoingGames(await resOngoing.json());

        const resCompleted = await fetch(
            `/api/admin/completed-games?startDate=${startDateUTC.toISOString()}&endDate=${endDateUTC.toISOString()}`,
            {
                method: 'GET',
                headers,
                credentials: 'include',
            }
        );
        setCompletedGames(await resCompleted.json());

        const resBets = await fetch(
            `/api/admin/total-bets?startDate=${startDateUTC.toISOString()}&endDate=${endDateUTC.toISOString()}`,
            {
                method: 'GET',
                headers,
                credentials: 'include',
            }
        );
        const betData = await resBets.json();
        const defaultTotals = {
            usdt: 0,
            stars: 0,
            token: 0,
            };
        if (betData.totalBets) { // Corrected key here
        betData.totalBets.forEach(currency => {
        defaultTotals[currency.currency] = currency.totalBets;
            });
            }
        setUsdtBets(defaultTotals.usdt);
        setStarsBets(defaultTotals.stars);
        setTokenBets(defaultTotals.token);

        const resUsers = await fetch('/api/admin/users?page=1&limit=1', {
            method: 'GET',
            headers,
            credentials: 'include',
        });
        const userData = await resUsers.json();
        setUserCount(userData.totalUsers);

        
    };

     const fetchPendingWithdrawals = async () => {
        setIsLoadingWithdrawals(true);
        try {
            const res = await fetch('/api/admin/pending-withdrawals', {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
            });
            const data = await res.json();
            setPendingWithdrawals(data);
        } catch (error) {
            console.error('Error fetching pending withdrawals:', error);
        } finally {
            setIsLoadingWithdrawals(false);
        }
    };

    const handleCompleteWithdrawal = async (transactionId) => {
        try {
            const res = await fetch('/api/admin/complete-withdrawal', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ transactionId }),
            });
            const data = await res.json();
            if (data.success) {
                fetchPendingWithdrawals();
                // Optionally show success message
            }
        } catch (error) {
            console.error('Error completing withdrawal:', error);
        }
    };

    const handleCancelWithdrawal = async (transactionId) => {
        try {
            const res = await fetch('/api/admin/cancel-withdrawal', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ transactionId }),
            });
            const data = await res.json();
            if (data.success) {
                fetchPendingWithdrawals();
                // Optionally show success message
            }
        } catch (error) {
            console.error('Error cancelling withdrawal:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPendingWithdrawals();
    }, [startDate, endDate]);

    useEffect(() => {
        const socket = io('https://gamestar24.com');

        socket.on('queueUpdate', (data) => {
            const updatedQueueData = {
                blot: {
                    free: 0,
                    five: 0,
                    ten: 0,
                    twenty: 0,
                },
                rps: {
                    free: 0,
                    five: 0,
                    ten: 0,
                    twenty: 0,
                },
                carrom: {
                    free: 0,
                    five: 0,
                    ten: 0,
                    twenty: 0,
                },
                backgammon: {
                    free: 0,
                    five: 0,
                    ten: 0,
                    twenty: 0,
                },
                poker: { free: 0, five: 0, ten: 0, twenty: 0 },
            };

            data.forEach((queue) => {
                if (queue.gameMode === 'blot') {
                    if (queue.betAmount === 25) updatedQueueData.blot.free = queue.count;
                    if (queue.betAmount === 300 || queue.betAmount === 3) updatedQueueData.blot.five = queue.count;
                    if (queue.betAmount === 1200 || queue.betAmount === 12) updatedQueueData.blot.ten = queue.count;
                    if (queue.betAmount === 6000 || queue.betAmount === 60) updatedQueueData.blot.twenty = queue.count;
                }
                if (queue.gameMode === 'rps') {
                    if (queue.betAmount === 25) updatedQueueData.rps.free = queue.count;
                    if (queue.betAmount === 300 || queue.betAmount === 3) updatedQueueData.rps.five = queue.count;
                    if (queue.betAmount === 1200 || queue.betAmount === 12) updatedQueueData.rps.ten = queue.count;
                    if (queue.betAmount === 6000 || queue.betAmount === 60) updatedQueueData.rps.twenty = queue.count;
                }
                if (queue.gameMode === 'carrom') {
                    if (queue.betAmount === 25) updatedQueueData.carrom.free = queue.count;
                    if (queue.betAmount === 300 || queue.betAmount === 3) updatedQueueData.carrom.five = queue.count;
                    if (queue.betAmount === 1200 || queue.betAmount === 12) updatedQueueData.carrom.ten = queue.count;
                    if (queue.betAmount === 6000 || queue.betAmount === 60) updatedQueueData.carrom.twenty = queue.count;
                }
                if (queue.gameMode === 'backgammon') {
                    if (queue.betAmount === 25) updatedQueueData.backgammon.free = queue.count;
                    if (queue.betAmount === 300 || queue.betAmount === 3) updatedQueueData.backgammon.five = queue.count;
                    if (queue.betAmount === 1200 || queue.betAmount === 12) updatedQueueData.backgammon.ten = queue.count;
                    if (queue.betAmount === 6000 || queue.betAmount === 60) updatedQueueData.backgammon.twenty = queue.count;
                }
                if (queue.gameMode === 'poker') {
    if (queue.betAmount === 25) updatedQueueData.poker.free = queue.count;
    if (queue.betAmount === 300 || queue.betAmount === 3) updatedQueueData.poker.five = queue.count;
    if (queue.betAmount === 1200 || queue.betAmount === 12) updatedQueueData.poker.ten = queue.count;
    if (queue.betAmount === 6000 || queue.betAmount === 60) updatedQueueData.poker.twenty = queue.count;
}

            });

            setQueueData(updatedQueueData);
        });

        socket.on('ongoingGamesUpdate', (data) => {
            setOngoingGames(data);
        });

        return () => socket.disconnect();
    }, []);

    // Play sound when queueData changes
    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.play().catch((error) => {
                console.error('Error playing sound:', error);
            });
        }
    }, [queueData]);

    return (
        <div className="admin-dashboard-container">
            {/* Audio element for sound */}
            <audio ref={audioRef} src="/sounds/game_start.mp3" preload="auto" />

            <h1 className="dashboard-title">Admin Dashboard</h1>

            {/* Date Range Picker */}
            <div className="date-range-picker">
                <h2>Select Date Range</h2>
                <div className="date-picker-group">
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        dateFormat="yyyy-MM-dd"
                        className="date-picker"
                    />
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        dateFormat="yyyy-MM-dd"
                        className="date-picker"
                    />
                </div>
            </div>

            <div className="dashboard-grid">
                {/* Queue Data */}
                <div className="dashboard-card">
                    <h2>Blot Queue</h2>
                    <ul>
                        <li className={queueData.blot.free !== 0 ? 'highlightQ' : ''}>
                            Token: <span>{queueData.blot.free}</span> players
                        </li>
                        <li className={queueData.blot.five !== 0 ? 'highlightQ' : ''}>
                            Standart: <span>{queueData.blot.five}</span> players
                        </li>
                        <li className={queueData.blot.ten !== 0 ? 'highlightQ' : ''}>
                            Pro: <span>{queueData.blot.ten}</span> players
                        </li>
                        <li className={queueData.blot.twenty !== 0 ? 'highlightQ' : ''}>
                            Expert: <span>{queueData.blot.twenty}</span> players
                        </li>
                    </ul>
                </div>

                <div className="dashboard-card">
                    <h2>RPS Queue</h2>
                    <ul>
                        <li className={queueData.rps.free !== 0 ? 'highlightQ' : ''}>
                            Token: <span>{queueData.rps.free}</span> players
                        </li>
                        <li className={queueData.rps.five !== 0 ? 'highlightQ' : ''}>
                            Standart: <span>{queueData.rps.five}</span> players
                        </li>
                        <li className={queueData.rps.ten !== 0 ? 'highlightQ' : ''}>
                            Pro: <span>{queueData.rps.ten}</span> players
                        </li>
                        <li className={queueData.rps.twenty !== 0 ? 'highlightQ' : ''}>
                            Expert: <span>{queueData.rps.twenty}</span> players
                        </li>
                    </ul>
                </div>

                <div className="dashboard-card">
                    <h2>Carrom Queue</h2>
                    <ul>
                        <li className={queueData.carrom.free !== 0 ? 'highlightQ' : ''}>
                            Token: <span>{queueData.carrom.free}</span> players
                        </li>
                        <li className={queueData.carrom.five !== 0 ? 'highlightQ' : ''}>
                            Standart: <span>{queueData.carrom.five}</span> players
                        </li>
                        <li className={queueData.carrom.ten !== 0 ? 'highlightQ' : ''}>
                            Pro: <span>{queueData.carrom.ten}</span> players
                        </li>
                        <li className={queueData.carrom.twenty !== 0 ? 'highlightQ' : ''}>
                            Expert: <span>{queueData.carrom.twenty}</span> players
                        </li>
                    </ul>
                </div>

                <div className="dashboard-card">
                    <h2>Backgammon Queue</h2>
                    <ul>
                        <li className={queueData.backgammon.free !== 0 ? 'highlightQ' : ''}>
                            Token: <span>{queueData.backgammon.free}</span> players
                        </li>
                        <li className={queueData.backgammon.five !== 0 ? 'highlightQ' : ''}>
                            Standart: <span>{queueData.backgammon.five}</span> players
                        </li>
                        <li className={queueData.backgammon.ten !== 0 ? 'highlightQ' : ''}>
                            Pro: <span>{queueData.backgammon.ten}</span> players
                        </li>
                        <li className={queueData.backgammon.twenty !== 0 ? 'highlightQ' : ''}>
                            Expert: <span>{queueData.backgammon.twenty}</span> players
                        </li>
                    </ul>
                </div>

                <div className="dashboard-card">
    <h2>Poker Queue</h2>
    <ul>
        <li className={queueData.poker.free !== 0 ? 'highlightQ' : ''}>
            Token: <span>{queueData.poker.free}</span> players
        </li>
        <li className={queueData.poker.five !== 0 ? 'highlightQ' : ''}>
            Standart: <span>{queueData.poker.five}</span> players
        </li>
        <li className={queueData.poker.ten !== 0 ? 'highlightQ' : ''}>
            Pro: <span>{queueData.poker.ten}</span> players
        </li>
        <li className={queueData.poker.twenty !== 0 ? 'highlightQ' : ''}>
            Expert: <span>{queueData.poker.twenty}</span> players
        </li>
    </ul>
</div>

                {/* Ongoing Games */}
                <div className="dashboard-card">
                    <h2>Ongoing Games</h2>
<ul>
  {ongoingGames.map((game) => (
    <li key={game.id}>
      {game.gameMode === 'blot'
        ? 'Blot'
        : game.gameMode === 'carrom'
        ? 'Carrom'
        : game.gameMode === 'backgammon'
        ? 'Backgammon'
        : game.gameMode === 'poker'
        ? 'Poker'
        : 'Rock-Paper-Scissors'}
      : {game.id}, Duration: {game.duration} seconds , 
      Bet in {game.Bet !== 25 ? 'USDT' : 'Tokens'}:{' '}
      <span style={{ color: game.Bet !== 25 ? 'red' : 'white' }}>
        {game.Bet || 0}
      </span>

      <ul>
        {game?.userIds.map((player) => (
          <li
            key={player.id}
            style={{
              color: player.username.startsWith('ssd') ? 'red' : 'white',
              display: 'inline-block',
              marginRight: '10px'
            }}
          >
            {player.username}
          </li>
        ))}
      </ul>
    </li>
  ))}
</ul>
                </div>

                {/* Completed Games */}
                <div className="dashboard-card">
                    <h2>Completed Games</h2>
                    <p>{completedGames.totalGames} games completed</p>
                    <button
                        onClick={() => navigate('/admin/completed-games')}
                        className="view-all-button"
                        >
                            View All
                        </button>
                    </div>
    
                    {/* Total Bets */}
                    <div className="dashboard-card">
                        <h2>Total Bets</h2>
                        <p>USDT: {usdtBets}</p>
                        <p>Stars: {starsBets}</p>
                        <p>Token: {tokenBets}</p>
                    </div>
    
                    {/* Users */}
                    <div className="dashboard-card">
                        <h2>Users</h2>
                        <p>{userCount} total users</p>
                        <button
                            onClick={() => navigate('/admin/users')}
                            className="view-all-button"
                        >
                            View All
                        </button>
                    </div>
<div className="dashboard-card">
                <h2>Pending Withdrawals</h2>
                {isLoadingWithdrawals ? (
                    <p>Loading...</p>
                ) : pendingWithdrawals.length === 0 ? (
                    <p>No pending withdrawals</p>
                ) : (
                    <div className="withdrawals-list">
                        {pendingWithdrawals.map((withdrawal, index) => (
                            <div key={index} className="withdrawal-item">
                                <div className="withdrawal-info">
                                    <p>
                                        <strong>User:</strong> {withdrawal.username}
                                        <br />
                                        <strong>Amount:</strong> {withdrawal.amount} Stars (~{(withdrawal.amount / 100).toFixed(2)} USDT)
                                        <br />
                                        <strong>Wallet:</strong> {withdrawal.walletAddress}
                                        <br />
                                        <strong>Requested:</strong> {new Date(withdrawal.requestedAt).toLocaleString()}
                                        <br />
                                        <strong>Transaction ID:</strong> {withdrawal.transactionId}
                                    </p>
                                </div>
                                <div className="withdrawal-actions">
                                    <button 
                                        className="complete-button"
                                        onClick={() => handleCompleteWithdrawal(withdrawal.transactionId)}
                                    >
                                        Complete
                                    </button>
                                    <button 
                                        className="cancel-button"
                                        onClick={() => handleCancelWithdrawal(withdrawal.transactionId)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                <button
                    onClick={() => fetchPendingWithdrawals()}
                    className="refresh-button"
                >
                    Refresh
                </button>
            </div>

                    
                </div>
            </div>
        );
    };
    
    export default AdminDashboard;
    
